import BeelditWYSIWYGInput from "@beeldit/core/components/BeelditWYSIWYGInput";
import { t } from "i18next";

const config = {
  modelName: "configuration",
  modelPluralName: "configurations",
  endpoint: "configurations",
  tableConfig: {
    index: null,
    actions: [],
    rowActions: [],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  formSchema: {
    type: "object",
    properties: {
      booking_email_template: {
        type: "string",
        title: t("booking_email_template"),
      },
      booking_pdf_template: {
        type: "string",
        title: t("booking_pdf_template"),
      },
      agreement_pdf_template: {
        type: "string",
        title: t("booking_pdf_template"),
      },
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    booking_email_template: {
      "ui:widget": BeelditWYSIWYGInput
    },
    booking_pdf_template: {
      "ui:widget": BeelditWYSIWYGInput
    },
    agreement_pdf_template: {
      "ui:widget": BeelditWYSIWYGInput
    },
  },
};
export default config;
